<!--
 * @Author:
 * @LastEditTime: 2022-04-18 16:28:29
 * @Description: 新增、编辑api
-->
<template>
  <el-dialog
    v-dialogDrag
    width="565px"
    class="mini-dialog"
    :close-on-click-modal="false"
    :append-to-body="true"
    :visible.sync="operateApiProps.visible"
    :title="operateApiProps.title"
  >
    <el-form
      size="mini"
      label-width="150px"
      v-loading="formLoading"
      :rules="apiRules"
      ref="apiForm"
      :model="apiForm"
    >
      <el-form-item label="名称" prop="name">
        <el-input
          v-model="apiForm.name"
          :readonly="operateApiProps.editType === 'edit'"
          placeholder="请输入名称"
          size="small"
          clearable
        />
      </el-form-item>
      <el-form-item label="显示名称" prop="displayName">
        <el-input
          v-model="apiForm.displayName"
          placeholder="请输入显示名称"
          size="small"
          clearable
        />
      </el-form-item>
      <el-form-item label="声明集" prop="userClaims">
        <el-select
          size="small"
          multiple
          filterable
          clearable
          v-model="apiForm.userClaims"
          class="w-full"
          @change="changeClaims"
        >
          <el-option
            v-for="item in claimTypes"
            :key="item.id"
            :value="item.name"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input v-model="apiForm.description" placeholder="请输入描述" size="small" clearable />
      </el-form-item>
      <el-form-item label="启用" prop="enabled">
        <el-checkbox v-model="apiForm.enabled" />
      </el-form-item>
      <el-form-item label="显示在发现文档中" prop="showInDiscoveryDocument">
        <el-checkbox v-model="apiForm.showInDiscoveryDocument" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="text-center">
      <el-button size="small" type="primary" class="iconfont icon-save" @click="save()"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="cancel()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ApiResourceApi } from '@wiz-api/auth-server'
import { ClaimTypeApi } from '@wiz-api/account'

const uuid = require('uuid')

const resourceApi = new ApiResourceApi()
const claimTypeApi = new ClaimTypeApi()

export default {
  name: 'operateApiDialog',
  props: {
    operateApiProps: {
      type: Object,
      default: () => {
        return {
          title: '新增api',
          editType: 'create',
          visible: false,
        }
      },
    },
    apiForm: {
      type: Object,
      default: () => {
        return {
          name: '',
          displayName: '',
          description: '',
          userClaims: [],
          enabled: false,
          showInDiscoveryDocument: false,
        }
      },
    },
  },
  components: {},
  data() {
    return {
      formLoading: false,
      claimTypes: [], // 声明集
      initClaimTypes: [],
      apiRules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: ['blur', 'change'],
          },
        ],
      },
    }
  },
  watch: {
    'apiForm.userClaims': {
      deep: true,
      immediate: true,
      handler(newClaims, oldClaims) {
        console.log(newClaims, oldClaims, 'newClaims oldClaims')
      },
    },
  },
  computed: {},
  methods: {
    async findClaimTypes() {
      this.formLoading = true
      const [err, res] = await claimTypeApi.getAllList()
      this.formLoading = false
      if (!err) {
        this.claimTypes = res
        this.initClaimTypes = _.cloneDeep(this.claimTypes)
      }
    },
    changeClaims(claims) {
      // this.claimTypes = _.filter(this.initClaimTypes, (item) => {
      //   return !_.includes(claims, item.id)
      // })
    },
    removeClaims(claim) {
      const currentClaim = _.find(this.initClaimTypes, ['id', claim])
      this.$confirm(`确认要删除${currentClaim.name}么`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {})
        .catch(() => {
          return false
        })
    },
    cancel() {
      this.operateApiProps.visible = false
    },
    save() {
      this.$refs.apiForm.validate(async (valid) => {
        if (valid) {
          if (this.operateApiProps.editType === 'create') {
            const [err, res] = await resourceApi.create({ body: this.apiForm })
            if (!err) {
              this.$message.success({
                showClose: true,
                message: '新增成功',
              })
              this.operateApiProps.visible = false
              this.$emit('refreshList')
            }
            return
          }
          const [updateErr, updateRes] = await resourceApi.update(this.apiForm.id, {
            body: this.apiForm,
          })
          if (!updateErr) {
            this.$message.success({
              showClose: true,
              message: '修改成功',
            })
            this.operateApiProps.visible = false
            this.$emit('refreshList')
          }
        }
      })
    },
  },
  created() {
    this.findClaimTypes()
  },
}
</script>

<style scoped lang="scss"></style>
